<template>
  <div
    v-if="loading"
    class="d-flex align-center justify-center fill-height py-6"
  >
    <v-progress-circular indeterminate color="primary" />
  </div>

  <v-container v-else fill-height>
    <div
      v-if="
        (appointment?.status === 'scheduled' ||
          appointment?.status === 'in_progress') &&
        !_overTime
      "
      class="d-flex flex-column fill-width"
    >
      <v-row class="mb-2" justify="center">
        <v-col cols="6" md="3">
          <v-img :src="require('@/assets/queue_figure.png')" />
        </v-col>
      </v-row>

      <div
        class="d-flex flex-column align-center text-center limited-content mb-4"
      >
        <div class="text-h6 font-weight-regular mb-2">
          Você está na Fila do Gabinete
        </div>

        <div
          v-if="!meetLink && !showMeetLink"
          class="text-body-1 font-weight-light mb-2"
        >
          <strong>Importante:</strong> O horário de atendimento pode variar,
          podendo ser antecipado ou até sofrer pequenos atrasos, de acordo com a
          agenda do magistrado.
        </div>

        <div class="text-h6 font-weight-regular mb-2">
          Seu número de protocolo é: {{ appointment?.protocol }}
        </div>

        <div class="text-body-1 font-weight-light mb-4">
          <div class="text-h6 font-weight-regular mb-2" v-if="isUserTurn">
            <span>Chegou a sua vez</span>
          </div>

          <div v-if="meetLink">
            <v-alert
              v-if="!showMeetLink"
              class="mt-4 meet-link-alert"
              outlined
              dense
            >
              <div class="text-body-2">
                Quando chegar a sua vez, o link para o atendimento por vídeo
                será disponibilizado aqui.
              </div>
            </v-alert>

            <v-btn
              v-else
              class="text-none mt-1 pulse-glow"
              color="primary"
              :href="meetLink"
              target="_blank"
              @click="handleJoinMeeting"
            >
              Entrar na Reunião
              <v-icon right>mdi-open-in-new</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <v-row justify="center">
        <v-col cols="12" md="8">
          <v-card class="white" flat>
            <v-row no-gutters>
              <v-col
                v-for="(item, i) in _appointmentData"
                :key="i"
                class="pa-4"
                cols="6"
                md="4"
              >
                <div class="d-flex align-center fill-height side-border pl-3">
                  <div class="d-flex flex-column">
                    <div class="text-caption mb-n1">
                      {{ item.label }}
                    </div>

                    <div class="text-body-1 font-weight-bold gray2--text">
                      {{ item.value }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- <div class="d-flex justify-center mt-4">
        <v-btn class="text-none" color="primary" @click="finalizeAttendance()">
          Cancelar
        </v-btn>
      </div> -->
    </div>

    <div v-else class="d-flex flex-column fill-width">
      <v-row class="mb-2" justify="center">
        <v-col cols="8" sm="6" md="4" lg="3">
          <v-img :src="require('@/assets/undraw_schedule.png')" />
        </v-col>
      </v-row>

      <div
        class="d-flex flex-column align-center text-center limited-content mb-4"
      >
        <div class="text-h6 font-weight-bold mb-2">
          Atendimento Indisponível
        </div>

        <v-card class="py-6 px-8 rounded-md">
          <div class="text-body-1 font-weight-light mb-6">
            Não é possível acessar o Gabinete neste momento, pois o atendimento
            está
            <strong class="text-decoration-underline"
              >fora do horário programado</strong
            >
            ou
            <strong class="text-decoration-underline"
              >encerrado pelo magistrado responsável</strong
            >
            .
          </div>

          <div class="text-body-1 font-weight-light font-italic">
            Caso precise de orientações adicionais, entre em contato com um dos
            atendentes.
          </div>
        </v-card>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { eventBus } from "@/eventBus";
import {
  getAppointment,
  markAppointmentReady,
  markAppointmentIsNotReady,
} from "@/services/appointments";
import { handleAlert } from "@/utils";

export default {
  name: "QueueAppointment",

  data() {
    return {
      loading: true,
      isReady: false,
    };
  },

  async beforeMount() {
    eventBus.$on("attendance:time-out", this.handleTimeOut);
    eventBus.$on("appointments:started", this.handleAppointmentStarted);
    eventBus.$on("appointments:ready", this.handleAppointmentReady);
    eventBus.$on("appointments:finished", this.handleAppointmentFinished);
    eventBus.$on("appointments:reconnected", this.handleAppointmentReconnected);
    eventBus.$on("appointments:canceled", this.handleAppointmentCanceled);
    eventBus.$on("appointments:no_show", this.handleAppointmentNoShow);
    eventBus.$on("appointments:updated", this.handleAppointmentUpdated);
    eventBus.$on("appointments:not_found", this.handleAppointmentNotFound);
    eventBus.$on("appointments:in_progress", this.handleAppointmentInProgress);
    eventBus.$on(
      "appointments:client:ready",
      this.handleAppointmentClientReady
    );
  },

  mounted() {
    window.addEventListener("beforeunload", this.handlePageUnload);
    this.handleAppointmentSettings();
  },

  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handlePageUnload);
  },

  async beforeDestroy() {
    eventBus.$off("attendance:time-out", this.handleTimeOut);
    eventBus.$off("appointments:started", this.handleAppointmentStarted);
    eventBus.$off("appointments:finished", this.handleAppointmentFinished);
    eventBus.$off("appointments:ready", this.handleAppointmentReady);
    eventBus.$off(
      "appointments:reconnected",
      this.handleAppointmentReconnected
    );
    eventBus.$off("appointments:canceled", this.handleAppointmentCanceled);
    eventBus.$off("appointments:no_show", this.handleAppointmentNoShow);
    eventBus.$off("appointments:updated", this.handleAppointmentUpdated);
    eventBus.$off("appointments:not_found", this.handleAppointmentNotFound);
    eventBus.$off("appointments:in_progress", this.handleAppointmentInProgress);
    eventBus.$off(
      "appointments:client:ready",
      this.handleAppointmentClientReady
    );

    await this.handleLeaveAppointment();
    await this.markAsNotReady();
  },

  watch: {
    socket(val) {
      if (val) {
        this.handleAppointmentSettings();
      }
    },
  },

  computed: {
    ...mapState("socket", ["appointment", "attendance", "socket"]),

    meetLink() {
      return this.appointment?.meetingLink || null;
    },

    isUserTurn() {
      return this.appointment?.isUserTurn || false;
    },

    showMeetLink() {
      return this.appointment?.showMeetLink || false;
    },

    _appointmentData() {
      if (!this.appointment) {
        return [];
      }

      return [
        {
          label: this.$t("group"),
          value:
            this.appointment?.comarca?.name ||
            this.appointment?.desk?.comarca?.name ||
            "--",
        },
        {
          label: this.$t("subgroup"),
          value:
            this.appointment?.vara?.name ||
            this.appointment?.desk?.vara?.name ||
            "--",
        },
        {
          label: this.$t("desk"),
          value: this.appointment?.desk?.name || "--",
        },
        {
          label: "Horário Previsto",
          value: this.formatScheduledTime(this.appointment.slotStart) || "--",
        },
      ];
    },

    _overTime() {
      if (!this.appointment) return true;

      if (!this.appointment?.desk?.delayLimit) return false;

      const slotDate = new Date(this.appointment.slotStart);
      const now = new Date();

      const slotWithDelay = new Date(
        slotDate.getTime() + this.appointment.desk.delayLimit * 60 * 1000
      );

      return now > slotWithDelay;
    },
  },

  methods: {
    ...mapActions("socket", [
      "setShouldClearStorage",
      "clearAppointment",
      "setAppointment",
      "updateAppointment",
      "markAppointmentNotReady",
      "registerAppointmentSocket",
      "unregisterAppointmentSocket",
      "enterAppointment",
      "reconnectAppointment",
      "leaveAppointment",
      "setAppointmentReady",
      "joinAppointmentMeeting",
      "enterAppointmentMeet",
      "leaveAppointmentMeeting",
      "connectSocket",
    ]),

    async handleAppointmentSettings() {
      if (!this.socket) return;

      await this.$nextTick();

      const appointmentID =
        this.$route.params.appointmentID || this.appointment?._id;

      if (!appointmentID) {
        console.warn("No appointment ID available on mount");
        return;
      }

      try {
        await this.fetchAppointmentData();

        if (this.appointment.status === "finished") {
          this.handleAppointmentFinished();
        }

        await this.handleJoinAppointment();

        await this.markAsReady(
          (this.appointment.status === "scheduled" ||
            this.appointment.status === "in_progress") &&
            !this._overTime
        );
        await this.registerAppointmentSocket({ appointmentID });
      } catch (error) {
        console.error("Error initializing QueueAppointment:", error);
        this.handleAlert("Erro ao inicializar a página de fila.", "error");
      }
    },

    async handleAppointmentFinished(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      this.loading = true;

      const appointmentID = data.appointmentID;
      const deskID = data.deskID;

      if (appointmentID) {
        await this.unregisterAppointmentSocket({ appointmentID });
      }

      setTimeout(() => {
        this.setAppointment(null);
        this.clearAppointment();

        if (!this.appointment?.rating) {
          this.handleAlert(
            "O atendimento foi finalizado. Você será redirecionado para a pesquisa de satisfação.",
            "info"
          );

          this.handleRating({
            appointmentID: appointmentID,
            deskID: deskID,
          });
        } else {
          this.handleAlert("O atendimento foi finalizado.", "info");

          this.$router.push(
            { name: "Home" },
            () => {},
            () => {}
          );
        }

        this.loading = false;
      }, 2000);
    },

    async fetchAppointmentData() {
      this.loading = true;

      const appointmentID =
        this.$route.params.appointmentID || this.appointment?._id;

      if (!appointmentID) {
        console.warn("No appointment ID available");
        return;
      }

      try {
        const { data } = await getAppointment(appointmentID);
        this.setAppointment(data);
      } catch (error) {
        console.error("Erro ao buscar dados do appointment:", error);
        this.handleAlert(
          "Não foi possível carregar os dados do agendamento.",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },

    formatScheduledTime(dateString) {
      if (!dateString) return "--";
      const dateTime = new Date(dateString);
      const dayAndMonth = dateTime.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
      });
      return `${dayAndMonth} às ${dateTime.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
        day: dayAndMonth.day,
        month: dayAndMonth.month,
      })}`;
    },

    finalizeAttendance() {
      console.log("finalize");
      this.setShouldClearStorage(true);
      this.clearAppointment();
      this.$router.push({ path: "/home" }).catch(() => {});
    },

    handleTimeOut() {
      this.finalizeAttendance();
    },

    handleAppointmentStarted(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      const appointment = data?.appointment || data;

      this.handleAlert("O atendimento foi iniciado!", "success");

      if (appointment?.meetingLink) {
        this.redirectToMeeting(appointment.meetingLink);
      }
    },

    async handleAppointmentInProgress(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      console.log("handleAppointmentInProgress", data);
      if (data?.appointmentID) {
        try {
          const { data: appointment } = await getAppointment(
            data.appointmentID
          );
          this.setAppointment(appointment);
        } catch (error) {
          console.error("Erro ao buscar appointment:", error);
        }
      }
    },

    handleAppointmentReady(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      if (data?.isReady !== undefined) {
        this.isReady = data.isReady;
      }
    },

    async handleJoinAppointment() {
      if (!this.appointment?.protocol) {
        console.warn("No protocol available to join appointment");
        return;
      }

      try {
        await this.connectSocket();

        const payload = {
          appointmentID: this.appointment._id,
          protocol: this.appointment.protocol,
        };

        this.enterAppointment({
          data: payload,
          callback: (error, response) => {
            if (error) {
              console.error("enterAppointment:error", error);
              return;
            }

            if (response?.appointment) {
              this.updateAppointment(response.appointment);
            }

            const currentAppointment = this.appointment;
            if (
              currentAppointment?.status === "in_progress" &&
              currentAppointment?.meetingLink
            ) {
              this.redirectToMeeting(currentAppointment.meetingLink);
            }
          },
        });
      } catch (error) {
        console.error("Error entering appointment:", error);
      }
    },

    handleAppointmentReconnected(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      if (data?.status === "in_progress" && data?.meetingLink) {
        this.redirectToMeeting(data.meetingLink);
      }
    },

    handleAppointmentCanceled(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      this.handleAlert("Seu agendamento foi cancelado", "warning");
      this.clearAppointment();
      this.$router.push({ path: "/home" }).catch(() => {});
    },

    handleAppointmentNoShow(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      this.handleAlert("Você foi marcado como ausente", "warning");
      this.clearAppointment();
      this.$router.push({ path: "/home" }).catch(() => {});
    },

    handleAppointmentUpdated(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      console.log("Appointment updated:", data);
    },

    handleAppointmentNotFound(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      this.handleAlert("Agendamento não encontrado", "error");
      this.$router.push({ path: "/home" }).catch(() => {});
    },

    redirectToMeeting(meetingLink) {
      if (meetingLink) {
        window.open(meetingLink, "_blank");
      }
    },

    handleJoinMeeting() {
      if (!this.appointment?.protocol) return;

      this.joinAppointmentMeeting({
        data: {
          appointmentID: this.appointment._id,
          protocol: this.appointment.protocol,
        },
        callback: (error, response) => {
          if (error) {
            console.error("joinAppointmentMeeting:error", error);
            return;
          }

          console.log("Joined meeting:", response);
        },
      });

      this.enterAppointmentMeet({
        data: { appointmentID: this.appointment._id },
      });
    },

    handleLeaveMeeting() {
      if (!this.appointment?.protocol) return;

      this.leaveAppointmentMeeting({
        data: {
          appointmentID: this.appointment._id,
          protocol: this.appointment.protocol,
        },
        callback: (error, response) => {
          if (error) {
            console.error("leaveAppointmentMeeting:error", error);
            return;
          }
          console.log("Left meeting:", response);
        },
      });
    },

    handleAppointmentClientReady(data) {
      if (this.appointment?._id !== data.appointmentID) return;

      console.log("Client ready status changed:", data);
      if (data?.isReady !== undefined) {
        this.isReady = data.isReady;
      }
    },

    async handleLeaveAppointment() {
      if (!this.appointment?.protocol) {
        return;
      }

      try {
        this.leaveAppointment({
          data: {
            appointmentID: this.appointment._id,
            protocol: this.appointment.protocol,
          },
          callback: (error) => {
            if (error) {
              console.error("leaveAppointment:error", error);
            }
          },
        });
      } catch (error) {
        console.error("Error leaving appointment:", error);
      }
    },

    async markAsReady(scheduled) {
      if (!scheduled) return;

      if (this.appointment?.isReady) {
        this.isReady = true;
        return;
      }

      const appointmentID =
        this.$route.params.appointmentID || this.appointment?._id;

      if (!appointmentID) {
        console.warn("No appointment ID available to mark as ready");
        return;
      }

      try {
        await markAppointmentReady(appointmentID);
        this.isReady = true;
      } catch (error) {
        console.error("Failed to mark appointment as ready:", error);
      }
    },

    async markAsNotReady() {
      const appointmentID =
        this.$route.params.appointmentID || this.appointment?._id;

      if (!appointmentID || !this.isReady) {
        return;
      }

      try {
        this.markAppointmentNotReady({ appointmentID });

        await markAppointmentIsNotReady(appointmentID);
        this.isReady = false;
        console.log("Appointment marked as not ready via socket + API");
      } catch (error) {
        console.error("Failed to mark appointment as not ready:", error);
      }
    },

    handlePageUnload() {
      const appointmentID =
        this.$route.params.appointmentID || this.appointment?._id;

      if (!appointmentID || !this.isReady) {
        return;
      }

      const url = `${process.env.VUE_APP_API_URL}/appointments/${appointmentID}/mark-not-ready?apiKey=${process.env.VUE_APP_API_KEY}`;
      const blob = new Blob([JSON.stringify({})], {
        type: "application/json",
      });

      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, blob);
        console.log(
          "Beacon fallback sent (server will auto-cleanup via socket disconnect)"
        );
      }

      this.isReady = false;
    },

    handleRating(params, query) {
      this.$router.push(
        {
          name: "RatingFormAppointment",
          params,
          query,
        },
        () => {},
        () => {}
      );
    },

    handleAlert,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
